import React from "react";

const ItemComposer = ({ item, index, handleShowComposer }) => {

  return (
    <div key={index} className="m-8 p-4 px-5 mx-auto rounded-lg shadow-lg hover:shadow-xl border border-l-4 border-gray-400">
      <div className="flex flex-col w-full mb-2">
        <h1 onClick={handleShowComposer} className="text-xl sm:text-3xl font-semibold title-font cursor-pointer hover:text-pblue mb-4 text-gray-700"> {item?.firstName} {item?.lastName} </h1>
      </div>

      <div className="space-y-1.5">
        {item?.dateOfBirth &&
          <p className="leading-relaxed text-sm"><span className="font-medium">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="inline w-4 h-4 mr-1 text-pblue mb-1">
              <path fillRule="evenodd" d="M7.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM3.751 20.105a8.25 8.25 0 0116.498 0 .75.75 0 01-.437.695A18.683 18.683 0 0112 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 01-.437-.695z" clipRule="evenodd" />
            </svg>Birth </span>: {item?.dateOfBirth}
          </p>
        }

        {item?.dateOfDeath && <p className="leading-relaxed text-sm"><span className="font-medium">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="inline w-4 h-4 mr-1 text-red-500 mb-1">
            <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-1.72 6.97a.75.75 0 10-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 101.06 1.06L12 13.06l1.72 1.72a.75.75 0 101.06-1.06L13.06 12l1.72-1.72a.75.75 0 10-1.06-1.06L12 10.94l-1.72-1.72z" clipRule="evenodd" />
          </svg>
            Death </span>: {item?.dateOfDeath}
        </p>
        }
        {item?.gender &&
          <p className="leading-relaxed text-sm"><span className="font-medium">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="inline w-4 h-4 mr-1 text-pblue mb-1">
              <path fillRule="evenodd" d="M8.603 3.799A4.49 4.49 0 0112 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 013.498 1.307 4.491 4.491 0 011.307 3.497A4.49 4.49 0 0121.75 12a4.49 4.49 0 01-1.549 3.397 4.491 4.491 0 01-1.307 3.497 4.491 4.491 0 01-3.497 1.307A4.49 4.49 0 0112 21.75a4.49 4.49 0 01-3.397-1.549 4.49 4.49 0 01-3.498-1.306 4.491 4.491 0 01-1.307-3.498A4.49 4.49 0 012.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 011.307-3.497 4.49 4.49 0 013.497-1.307zm7.007 6.387a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clipRule="evenodd" />
            </svg>Gender </span>: {item?.gender}
          </p>
        }
        {item?.nationality_id &&
          <p className="leading-relaxed text-sm"><span className="font-medium">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="transform rotate-180 inline w-4 h-4 mr-1 text-yellowgray mb-1">
              <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-4.28 9.22a.75.75 0 000 1.06l3 3a.75.75 0 101.06-1.06l-1.72-1.72h5.69a.75.75 0 000-1.5h-5.69l1.72-1.72a.75.75 0 00-1.06-1.06l-3 3z" clipRule="evenodd" />
            </svg>
              Nationality </span>: {item?.nationality_id?.map((i) => (<>{i}{','}</>))}
          </p>
        }
      </div>
      <div className="flex justify-end space-x-4 border-t md:border-t-0 pt-4 transform hover:-translate-y-1">
        <button onClick={handleShowComposer} className="flex flex-row items-center px-6 py-1 bg-blue-700 rounded-lg text-sm font-medium border-white text-white ">
          Read
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4">
            <path strokeLinecap="round" strokeLinejoin="round" d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3" />
          </svg>
        </button>
      </div>
    </div>
  )
}

export default  ItemComposer;
